import { Grid } from '@chakra-ui/react';
import { isNumber } from '@common/util/types';
import { useCallback, useState } from 'react';
import FormattedInput, { FormattedInputProps } from './FormattedInput';
import PlusOrMinusInput, {
    parseWithPlusOrMinus,
    PlusOrMinusValue,
} from './PlusOrMinusInput';

export default function FormattedWithPlusOrMinusInput({
    type,
    value,
    onChange,
    options,
    ...props
}: FormattedInputProps) {
    const [absoluteValue, setAbsoluteValue] = useState(
        isNumber(value) ? Math.abs(value) : 0
    );
    const [plusOrMinus, setPlusOrMinus] = useState<'+' | '-'>(
        isNumber(value) && value < 0 ? '-' : '+'
    );
    const handleChange = useCallback(
        (value: number, plusOrMinus: PlusOrMinusValue) => {
            onChange?.(parseWithPlusOrMinus(value, plusOrMinus));
        },
        [onChange]
    );

    if (!['currency', 'float', 'integer', 'percent'].includes(type))
        return <></>;

    return (
        <Grid gap={4} templateColumns={'60px 1fr'}>
            <PlusOrMinusInput
                name="plusOrMinus"
                value={plusOrMinus}
                onChange={(updatedPlusOrMinus: PlusOrMinusValue) => {
                    setPlusOrMinus(updatedPlusOrMinus);
                    handleChange(absoluteValue, updatedPlusOrMinus);
                }}
                variant={props.variant}
                size={props.size}
            />
            <FormattedInput
                {...props}
                type={type}
                value={typeof value === 'number' ? Math.abs(value) : undefined}
                onChange={(updatedValue) => {
                    const updatedAbsoluteValue = Math.abs(updatedValue);
                    setAbsoluteValue(updatedAbsoluteValue);
                    handleChange(updatedAbsoluteValue, plusOrMinus);
                }}
                options={{ ...options, min: 0 }}
            />
        </Grid>
    );
}
